import { Navigate, Outlet } from 'react-router-dom';

import { LoadingSpinner } from '../../components';
import { AuthState, useAuth, useNetwork } from '../../providers';
import { PATHS } from '../constants';

export function ProtectedRoute({ children }: { children?: JSX.Element }) {
  const { authState } = useAuth();
  const { isOnline } = useNetwork();

  if (authState === AuthState.LOADING) {
    return (
      <div className='grid h-dvh w-screen place-items-center'>
        <LoadingSpinner />
      </div>
    );
  }
  if (authState === AuthState.LOGGED_IN) return children ?? <Outlet />;

  if (isOnline) {
    return <Navigate to={PATHS.Home} />;
  }
}
